import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, createVNode as _createVNode, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  class: "relative z-10",
  "aria-labelledby": "contact-heading"
}
const _hoisted_2 = { class: "py-8 text-3xl text-center text-white bg-clay-500" }
const _hoisted_3 = { class: "px-4 pb-16 mx-auto max-w-7xl sm:px-6 lg:px-8" }
const _hoisted_4 = { class: "pt-12 border border-t-0 border-b-2 border-x-0" }
const _hoisted_5 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-x-8"
}
const _hoisted_6 = { class: "pt-12 border border-t-0 border-b-2 border-x-0" }
const _hoisted_7 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-x-8"
}
const _hoisted_8 = { class: "pt-12 border border-t-0 border-b-2 border-x-0" }
const _hoisted_9 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-2 lg:gap-x-8"
}
const _hoisted_10 = { class: "pt-12 border border-t-0 border-b-2 border-x-0" }
const _hoisted_11 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-x-8"
}
const _hoisted_12 = { class: "pt-12 border border-t-0 border-b-2 border-x-0" }
const _hoisted_13 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-x-8"
}
const _hoisted_14 = { class: "pt-12 border border-t-0 border-b-2 border-x-0" }
const _hoisted_15 = {
  key: 1,
  class: "grid grid-cols-1 gap-4 px-8 pt-8 mb-8 sm:grid-cols-1 md:grid-cols-2 lg:grid-cols-4 lg:gap-x-8"
}

import {defineComponent, onMounted, ref, Ref} from "vue";
import {client} from '@/shared';
import {
    GetContentForCommunityLandingPageRequest, GetContentForCommunityLandingPageResponse
} from "@/dtos";
import OpportunityCard from "../Opportunities/OpportunityCard.vue";
import TalentProfileCard from "../Talent/TalentProfileCard.vue";
import TheatreCompanyCard from "../TheatreCompanies/TheatreCompanyCard.vue";
import CollegeProgramCard from "../CollegePrograms/CollegeProgramCard.vue";
import SkeletonCard from "@/main/components/skeletons/SkeletonCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'Community',
  setup(__props) {

// @ts-ignore
onMounted(async () => {
    await getContentForCommunityPage();
});

const getContentResponse: Ref<GetContentForCommunityLandingPageResponse>  = ref({});

const isFetching = ref(true);
const getContentForCommunityPage = async () => {
    await client.get<GetContentForCommunityLandingPageResponse>(new GetContentForCommunityLandingPageRequest())
        .then(response => {
            isFetching.value = false;
            getContentResponse.value = response;
        });
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createElementVNode("p", _hoisted_2, [
      _cache[0] || (_cache[0] = _createElementVNode("span", { class: "inline mr-1 italic text-gray-200" }, "Near:", -1)),
      _createTextVNode(_toDisplayString(getContentResponse.value.locationFormattedAddress), 1)
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _cache[1] || (_cache[1] = _createStaticVNode("<div class=\"mx-auto max-w-7xl sm:px-6 lg:px-8\"><div class=\"relative sm:overflow-hidden\"><div class=\"relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8\"><h4 class=\"text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl\" id=\"auditions\"> Auditions &amp; Jobs </h4><h2 class=\"pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl\"> Audition notices and job opportunities in theatre </h2></div></div></div>", 1)),
        (isFetching.value)
          ? (_openBlock(), _createBlock(SkeletonCard, {
              key: 0,
              class: "mt-4",
              "card-style": "long",
              "num-of-cards": 2
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getContentResponse.value.auditions, (audition) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: audition.id
                }, [
                  _createVNode(OpportunityCard, { opportunity: audition }, null, 8, ["opportunity"])
                ]))
              }), 128))
            ])),
        _cache[2] || (_cache[2] = _createElementVNode("div", { class: "px-8" }, [
          _createElementVNode("a", {
            href: "/opportunities/theatre-auditions",
            class: "block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700"
          }, " View all auditions & jobs")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_6, [
        _cache[3] || (_cache[3] = _createStaticVNode("<div class=\"mx-auto max-w-7xl sm:px-6 lg:px-8\"><div class=\"relative sm:overflow-hidden\"><div class=\"relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8\"><h4 class=\"text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl\" id=\"classes\"> Classes &amp; Camps </h4><h2 class=\"pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl\"> Improve your craft with theatre classes, camps and webinars </h2></div></div></div>", 1)),
        (isFetching.value)
          ? (_openBlock(), _createBlock(SkeletonCard, {
              key: 0,
              class: "mt-4",
              "card-style": "long",
              "num-of-cards": 2
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_7, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getContentResponse.value.classes, (opportunity) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: opportunity.id
                }, [
                  _createVNode(OpportunityCard, { opportunity: opportunity }, null, 8, ["opportunity"])
                ]))
              }), 128))
            ])),
        _cache[4] || (_cache[4] = _createElementVNode("div", { class: "px-8" }, [
          _createElementVNode("a", {
            href: "/opportunities/theatre-education",
            class: "block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700"
          }, " View all classes & camps ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _cache[5] || (_cache[5] = _createStaticVNode("<div class=\"mx-auto max-w-7xl sm:px-6 lg:px-8\"><div class=\"relative sm:overflow-hidden\"><div class=\"relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8\"><h4 class=\"text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl\" id=\"performances\"> Performances </h4><h2 class=\"pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl\"> Theatre performances and festivals. Musicals, plays, operas and more! </h2></div></div></div>", 1)),
        (isFetching.value)
          ? (_openBlock(), _createBlock(SkeletonCard, {
              key: 0,
              class: "mt-4",
              "card-style": "long",
              "num-of-cards": 2
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_9, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getContentResponse.value.performances, (performance) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: performance.id
                }, [
                  _createVNode(OpportunityCard, { opportunity: performance }, null, 8, ["opportunity"])
                ]))
              }), 128))
            ])),
        _cache[6] || (_cache[6] = _createElementVNode("div", { class: "px-8" }, [
          _createElementVNode("a", {
            href: "/opportunities/performances",
            class: "block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700"
          }, " View all performance listings ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_10, [
        _cache[7] || (_cache[7] = _createStaticVNode("<div class=\"mx-auto max-w-7xl sm:px-6 lg:px-8\"><div class=\"relative sm:overflow-hidden\"><div class=\"relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8\"><h4 class=\"text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl\" id=\"talent-profiles\"> Talent Profiles </h4><h2 class=\"pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl\"> Network with theatre actors, singers and artistic staff </h2></div></div></div>", 1)),
        (isFetching.value)
          ? (_openBlock(), _createBlock(SkeletonCard, {
              key: 0,
              class: "mt-4",
              "card-style": "long",
              "num-of-cards": 2
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_11, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getContentResponse.value.talentProfiles, (profile) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: profile.id
                }, [
                  _createVNode(TalentProfileCard, { talent: profile }, null, 8, ["talent"])
                ]))
              }), 128))
            ])),
        _cache[8] || (_cache[8] = _createElementVNode("div", { class: "px-8" }, [
          _createElementVNode("a", {
            href: "/talent",
            class: "block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700"
          }, " View all talent profiles ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_12, [
        _cache[9] || (_cache[9] = _createStaticVNode("<div class=\"mx-auto max-w-7xl sm:px-6 lg:px-8\"><div class=\"relative sm:overflow-hidden\"><div class=\"relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8\"><h4 class=\"text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl\" id=\"theatre-companies\"> Theatre Companies </h4><h2 class=\"pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl\"> Find performing arts companies and organizations </h2></div></div></div>", 1)),
        (isFetching.value)
          ? (_openBlock(), _createBlock(SkeletonCard, {
              key: 0,
              class: "mt-4",
              "card-style": "long",
              "num-of-cards": 2
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getContentResponse.value.theatreCompanies, (company) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: company.id
                }, [
                  _createVNode(TheatreCompanyCard, { company: company }, null, 8, ["company"])
                ]))
              }), 128))
            ])),
        _cache[10] || (_cache[10] = _createElementVNode("div", { class: "px-8" }, [
          _createElementVNode("a", {
            href: "/theatre-companies",
            class: "block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700"
          }, " View all theatre companies ")
        ], -1))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _cache[11] || (_cache[11] = _createStaticVNode("<div class=\"mx-auto max-w-7xl sm:px-6 lg:px-8\"><div class=\"relative sm:overflow-hidden\"><div class=\"relative px-4 py-8 sm:px-6 sm:py-6 lg:py-6 lg:px-8\"><h4 class=\"text-2xl font-extrabold tracking-tight text-center text-clay-950 sm:text-2xl lg:text-4xl\" id=\"college-theatre-programs\"> College Theatre Programs </h4><h2 class=\"pt-2 text-xl tracking-tight text-center text-slate-800 sm:text-m lg:text-xl\"> Directory of college theatre programs including degrees offered, majors available and notable alumni </h2></div></div></div>", 1)),
        (isFetching.value)
          ? (_openBlock(), _createBlock(SkeletonCard, {
              key: 0,
              class: "mt-4",
              "card-style": "long",
              "num-of-cards": 2
            }))
          : (_openBlock(), _createElementBlock("div", _hoisted_15, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(getContentResponse.value.collegePrograms, (program) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: program.id
                }, [
                  _createVNode(CollegeProgramCard, { program: program }, null, 8, ["program"])
                ]))
              }), 128))
            ])),
        _cache[12] || (_cache[12] = _createElementVNode("div", { class: "px-8" }, [
          _createElementVNode("a", {
            href: "/college-programs",
            class: "block px-4 py-2 mt-2 font-medium text-center text-white border border-transparent rounded-md shadow-sm bg-clay-950 bg-origin-border hover:from-clay-700 hover:to-electric-700"
          }, " View all college theatre programs ")
        ], -1))
      ])
    ])
  ]))
}
}

})